<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="8"
    height="5.3131289"
  >
    <defs id="defs8" />
    <path
      fill="#ffffff"
      id="path4"
      d="M 0.37710545,2.1818182 3.1784508,5.0101018 c 0.4309746,0.4040364 1.1582473,0.4040364 1.5892291,0 L 7.6498327,2.1818182 C 7.8653164,1.9393964 8,1.61616 8,1.2929309 8,0.5925891 7.4343418,0 6.7340072,0 6.3838399,0 6.0336727,0.1346836 5.8181817,0.3771055 L 3.9595927,2.2356873 2.1818181,0.3771055 C 1.9663272,0.1346836 1.6430981,0 1.2929308,0 0.91582538,0 0.59258909,0.1346836 0.37710545,0.3771055 0.13468364,0.6195273 0,0.9427636 0,1.2929309 0,1.6430982 0.13468364,1.9663273 0.37710545,2.1818182 Z"
    />
  </svg>
</template>
<script>
export default {
  name: "down-icon"
};
</script>
